export enum Lng {
  LV = 'lv',
  EN = 'en',
}

export enum EmitStatus {
  SUCCESS = 'success',
  ERROR = 'error',
}

export enum ActionType {
  GET = 'GET',
  SEND = 'SEND',
}

export enum Direction {
  LEFT = 'LEFT',
  RIGHT = 'RIGHT',
}

export enum BlockType {
  BIG = 'BIG',
  MEDIUM = 'MEDIUM',
  SMALL = 'SMALL',
}

export enum Color {
  GRAY = 'gray',
}

export enum Orientation {
  LANDSCAPE = 'landscape',
  PORTRAIT = 'portrait',
}

export enum EIDs {
  ABOUT = 'par-projektu',
  EXPEDITION = 'ekspedicijas',
  HOW = 'ka-pievienot',
  THEMES = 'temas',
  HOME = 'home',
  PRIVACY = 'privatuma-politika',
}

export enum EStoryType {
  MYSELF = 'myself',
  INTERVIEW = 'interview',
  OTHER = 'other',
}

export enum EUploadErrors {
  FILE_TOO_LARGE = 'file-too-large',
  FILE_INVALID_TYPE = 'file-invalid-type',
  TOO_MANY_FILES = 'too-many-files',
}
